import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AutocompleteOption } from '../field-text/field-text.component';
import { ImportService } from '../../cms/import/import.service';

@Component({
  selector: 'app-face-item',
  templateUrl: './face-item.component.html',
  styleUrls: ['./face-item.component.scss'],
})
export class FaceItemComponent implements OnInit {
  @Input() faceId: number = 0;
  @Input() thumbnail: string = '';
  @Input() personValue?: AutocompleteOption | undefined;
  @Input() disabled: boolean = false;

  value: string = '';

  @Output() personChange: EventEmitter<{
    faceId: number;
    person: AutocompleteOption | undefined;
  }> = new EventEmitter();

  constructor(private importService: ImportService) {}

  ngOnInit(): void {}

  onPersonChange(person: AutocompleteOption | undefined): void {
    this.personChange.emit({ faceId: this.faceId, person });
  }

  onFieldFocus(): void {
    // Mark the field as being edited to prevent refresh from overwriting user input
    // Use a unique identifier for each face
    this.importService.markFieldAsBeingEdited(`face-person-${this.faceId}`);
  }

  onFieldBlur(): void {
    // Remove the field from being edited when user finishes
    this.importService.unmarkFieldAsBeingEdited(`face-person-${this.faceId}`);
  }
}
